import { useApi } from "@/.shared/.api/integration";
import { GENERAL_NOT_FOUND } from "@/.shared/errors/codes";
import { ApiError } from "@/.shared/services/http";
import { useIntl } from "@/.shared/services/i18n";
import { useModalService } from "@/.shared/services/modal-service";
import { toastError } from "@/.shared/services/notification-service";
import BorradorOperacionDetailPanel from "@/components/borradores-operacion/BorradorOperacionDetailPanel.vue";

export async function mostrarDetalleBorrador(idBorrador: string){
  const api = useApi();
  const modal = useModalService();
  const intl = useIntl();

  const title = String(intl.i18n.t("borradores-operacion.detalle.titulo"));
  try{
    const response = await api.callStandardApi("getBorradorOperacionDetail", { showLoading: true }, idBorrador);
    await modal.showModal(BorradorOperacionDetailPanel, { model: response }, { title, width: 800, height: 700 });
  } catch (e: any) {
    if (e instanceof ApiError && e.details?.errorList.length === 1 && [GENERAL_NOT_FOUND].includes(e.details.errorList[0].Code)) {
      toastError(intl.i18n.t(`shared.errors.api.Operaciones.DraftNotFound`));
    } else {
      throw e;
    }
  }
}
